import type React from 'react';
import type { Boundaries, TimePreset, TimeWindow } from '../types';
import TimeWindowBody from './TimeWindowBody';
import TimeWindowHeader from './TimeWindowHeader';

interface TimeWindowOverlayProps {
  timeWindow: TimeWindow;
  boundaries: Boundaries;
  timePresets: TimePreset[];
  selectedPreset: TimePreset | null;
  isFilterApplied: boolean;
  showPresets?: boolean;
  onTimeInputChange: (value: string, field: 'startTime' | 'endTime') => void;
  onTimeBlur: (event: React.FocusEvent<HTMLInputElement>, field: 'startTime' | 'endTime', minValue: string, maxValue: string) => void;
  onSliderChange: (startTime: string, endTime: string) => void;
  onPresetSelect: (preset: TimePreset) => void;
  onClearFilter: () => void;
}

const TimeWindowOverlay: React.FC<TimeWindowOverlayProps> = ({
  timeWindow,
  boundaries,
  timePresets,
  selectedPreset,
  isFilterApplied,
  showPresets = true,
  onTimeInputChange,
  onTimeBlur,
  onSliderChange,
  onPresetSelect,
  onClearFilter,
}) => {
  return (
    <div className='!max-h-[360px] flex h-[360px] w-96 flex-col gap-2.5 rounded-md border border-gray-7 bg-white py-2.5 shadow-lg'>
      <TimeWindowHeader
        timeWindow={timeWindow}
        boundaries={boundaries}
        isFilterApplied={isFilterApplied}
        onTimeInputChange={onTimeInputChange}
        onTimeBlur={onTimeBlur}
        onClearFilter={onClearFilter}
      />
      <TimeWindowBody
        timeWindow={timeWindow}
        boundaries={boundaries}
        timePresets={timePresets}
        selectedPreset={selectedPreset}
        showPresets={showPresets}
        onSliderChange={onSliderChange}
        onPresetSelect={onPresetSelect}
      />
    </div>
  );
};

export default TimeWindowOverlay;
